import axios from "axios";

// ✅ Get API Base URL from env
const API_BASE_URL = process.env.REACT_APP_API_URL;

// ✅ Dynamic IMAGE BASE URL (using same domain from env)
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "https://online-tech.in/companymedicineImage/";

export const fetchMedicinesByStore = async (
  storeId,
  pageNumber = 1,
  pageSize = 10
) => {
  if (!storeId) {
    console.warn("⚠️ storeId missing");
    return [];
  }

  try {
    // ✅ Using env URL for API
    const url = `${API_BASE_URL}Medicine/GetMedicineByStore?store=${storeId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    console.log("📡 API CALL 👉", url);

    const response = await axios.get(url);

    console.log("✅ RESPONSE 👉", response.data);

    const rawData = response?.data?.data;

    if (!Array.isArray(rawData)) {
      console.warn("❌ No array data मिला", response.data);
      return [];
    }

    // 🔥 IMPORTANT FIX: normalize id
    const formatted = rawData.map((item) => ({
      ...item,

      // ✅ STANDARD PRODUCT ID (MOST IMPORTANT FIX)
      id: item.companyMedicineId,

      // optional safety alias (future use)
      productId: item.companyMedicineId,

      image: item.image
        ? `${IMAGE_BASE_URL}${item.image.trim().replace(/\s/g, "%20")}`
        : "https://placehold.co/100x100?text=No+Image",
    }));

    console.log("💊 FINAL DATA 👉", formatted);

    return formatted;
  } catch (error) {
    console.error("❌ API ERROR:", error?.response || error.message);
    return [];
  }
};